// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"styles_dropdown__38kOA","dropdownOptions":"styles_dropdownOptions__2xsto","open":"styles_open__2NZuF","modifyTable":"styles_modifyTable__3GEem"};